import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'ZeroDash',
})
export class ZeroDashPipe implements PipeTransform {
  transform(value: any): any {
    return value || '-';
  }
}
